import { ICartEntryType } from './types';
import type { ICartEntry, ICartEntryOffer, ICartEntryReward } from './types';

type IGetItemIdGetterMap = { [key in ICartEntryType]: (ce: ICartEntry) => string };

const itemIdGetterMap: IGetItemIdGetterMap = {
  [ICartEntryType.REWARD]: (ce: ICartEntryReward) => ce.details.reward._id,
  [ICartEntryType.OFFER]: (ce: ICartEntryOffer) => ce.details.offer._id,
};

const getCartEntryItemId = (cartEntry: ICartEntry) => itemIdGetterMap[cartEntry.type](cartEntry);

export const isCartEntryEqual = (cartEntry: ICartEntry, cartEntryToCompare: ICartEntry) =>
  cartEntry.referenceId === cartEntryToCompare.referenceId ||
  (cartEntry.type === cartEntryToCompare.type &&
    getCartEntryItemId(cartEntry) === getCartEntryItemId(cartEntryToCompare));
